import React from 'react'
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

function TabSize() {
  return (
    <>
      <Tabs defaultActiveKey="second">
        <Tab eventKey="first" title="XS"> <div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>34.5</td>
                <td>88</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>27</td>
                <td>69</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>37</td>
                <td>94</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>30</td>
                  <td>76</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>37</td>
                  <td>94</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
        <Tab eventKey="second" title="S"> <div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>36.5</td>
                <td>93</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>29</td>
                <td>74</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>39</td>
                <td>99</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>32</td>
                  <td>81</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>39</td>
                  <td>99</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
        <Tab eventKey="third" title="M"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>38.5</td>
                <td>98</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>31</td>
                <td>79</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>41</td>
                <td>104</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>34</td>
                  <td>86</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>41</td>
                  <td>104</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
        <Tab eventKey="four" title="L"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>40.5</td>
                <td>103</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>33</td>
                <td>84</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>43</td>
                <td>109</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>36</td>
                  <td>91</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>43</td>
                  <td>109</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
        <Tab eventKey="five" title="XL"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>42.5</td>
                <td>108</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>35</td>
                <td>99</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>45</td>
                <td>114</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>38</td>
                  <td>97</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>45</td>
                  <td>114</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
        <Tab eventKey="six" title="2XL"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>44.5</td>
                <td>113</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>37</td>
                <td>94</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>47</td>
                <td>119</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>40</td>
                  <td>102</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>47</td>
                  <td>119</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
          <Tab eventKey="seven" title="3XL"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>46</td>
                <td>117</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>39</td>
                <td>99</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>50</td>
                <td>127</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>42</td>
                  <td>107</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>50</td>
                  <td>127</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
          <Tab eventKey="eight" title="4XL"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>48</td>
                <td>122</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>41</td>
                <td>104</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>52</td>
                <td>132</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>44</td>
                  <td>112</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>52</td>
                  <td>132</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
          <Tab eventKey="nine" title="5XL"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>50</td>
                <td>127</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>43</td>
                <td>109</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>54</td>
                <td>137</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>46</td>
                  <td>117</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>54</td>
                  <td>137</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
          <Tab eventKey="ten" title="6XL"><div className="tab-table-content">
          <table width="300" cellSpacing="0" cellPadding="0">
            <tbody>
              <tr>
                <th>TOP</th>
                <th>Inches</th>
                <th>Cms</th>
              </tr>
              <tr>
                <td>Bust</td>
                <td>52</td>
                <td>132</td>
              </tr>
              <tr>
                <td>Waist</td>
                <td>45</td>
                <td>114</td>
              </tr>
              <tr>
                <td>Hips</td>
                <td>56</td>
                <td>142</td>
              </tr>
            </tbody>
          </table>
        </div>
          <div className="tab-table-content">
            <table width="300" cellSpacing="0" cellPadding="0">
              <tbody>
                <tr>
                  <th>BOTTOM</th>
                  <th>Inches</th>
                  <th>Cms</th>
                </tr>
                <tr>
                  <td>Waist</td>
                  <td>48</td>
                  <td>122</td>
                </tr>
                <tr>
                  <td>Hips</td>
                  <td>56</td>
                  <td>142</td>
                </tr>
              </tbody>
            </table>
          </div></Tab>
      </Tabs>
    </>
  )
}

export default TabSize
